var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenRxMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_604_25095)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#7742FE",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_25095)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_604_25095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.805 10.4976L16.475 6.74763C16.4049 6.66994 16.3193 6.60778 16.2237 6.56516C16.1281 6.52253 16.0247 6.50038 15.92 6.50013H9.92C9.67081 6.49716 9.42348 6.54331 9.19213 6.63593C8.96077 6.72855 8.74993 6.86584 8.57164 7.03995C8.39334 7.21406 8.2511 7.42159 8.15301 7.65068C8.05493 7.87978 8.00294 8.12595 8 8.37513V19.6251C8.00294 19.8743 8.05493 20.1205 8.15301 20.3496C8.2511 20.5787 8.39334 20.7862 8.57164 20.9603C8.74993 21.1344 8.96077 21.2717 9.19213 21.3643C9.42348 21.457 9.67081 21.5031 9.92 21.5001H18.08C18.3292 21.5031 18.5765 21.457 18.8079 21.3643C19.0392 21.2717 19.2501 21.1344 19.4284 20.9603C19.6067 20.7862 19.7489 20.5787 19.847 20.3496C19.9451 20.1205 19.9971 19.8743 20 19.6251V11.0001C19.9995 10.8143 19.93 10.6352 19.805 10.4976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0402 10.092C17.1377 10.2129 17.2788 10.2908 17.4332 10.3087L19.7053 10.3483L16.9531 7.29984L16.9119 9.66198C16.8966 9.81659 16.9427 9.97101 17.0402 10.092Z",
    fill: "#BBA0FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_604_25095)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_604_25095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 14V11.75C12.3125 11.3024 12.4903 10.8732 12.8068 10.5568C13.1232 10.2403 13.5524 10.0625 14 10.0625C14.4476 10.0625 14.8768 10.2403 15.1932 10.5568C15.5097 10.8732 15.6875 11.3024 15.6875 11.75V14C15.6875 14.4476 15.5097 14.8768 15.1932 15.1932C14.8768 15.5097 14.4476 15.6875 14 15.6875C13.5524 15.6875 13.1232 15.5097 12.8068 15.1932C12.4903 14.8768 12.3125 14.4476 12.3125 14ZM16.8125 14C16.8125 13.9254 16.7829 13.8539 16.7301 13.8011C16.6774 13.7484 16.6058 13.7188 16.5312 13.7188C16.4567 13.7188 16.3851 13.7484 16.3324 13.8011C16.2796 13.8539 16.25 13.9254 16.25 14C16.25 14.5967 16.0129 15.169 15.591 15.591C15.169 16.0129 14.5967 16.25 14 16.25C13.4033 16.25 12.831 16.0129 12.409 15.591C11.9871 15.169 11.75 14.5967 11.75 14C11.75 13.9254 11.7204 13.8539 11.6676 13.8011C11.6149 13.7484 11.5433 13.7188 11.4688 13.7188C11.3942 13.7188 11.3226 13.7484 11.2699 13.8011C11.2171 13.8539 11.1875 13.9254 11.1875 14C11.1884 14.697 11.4476 15.3689 11.9152 15.8858C12.3827 16.4027 13.0253 16.7279 13.7188 16.7984V17.9375C13.7188 18.0121 13.7484 18.0836 13.8011 18.1364C13.8539 18.1891 13.9254 18.2188 14 18.2188C14.0746 18.2188 14.1461 18.1891 14.1989 18.1364C14.2516 18.0836 14.2812 18.0121 14.2812 17.9375V16.7984C14.9747 16.7279 15.6173 16.4027 16.0848 15.8858C16.5524 15.3689 16.8116 14.697 16.8125 14Z",
    fill: "#7742FE"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_604_25095",
    x: 0,
    y: 0.5,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_25095"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_25095",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_604_25095",
    x: 3.5,
    y: 3.875,
    width: 21.75,
    height: 21.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.375,
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_25095"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_25095",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_25095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_604_25095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 15.0003,
    fill: "white",
    transform: "translate(8 6.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_604_25095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(9.5 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenRxMic);
export default __webpack_public_path__ + "static/media/gen-rx-mic.87a516ad06234d2b661b98ba98b4968d.svg";
export { ForwardRef as ReactComponent };